
import { DataType } from "@dndModels/Types";
import { ModelBase } from "@models/UpsertableBase";

/**
 * This is used for creating loot tables for creatures.
 * LootTable is a ModelBase and holds a specific list of options 
 * that can be rolled upon.
 * LootOption is an interface and contains specific items, 
 * and roll rules such as roll values that give it, and how many of the 
 * item are found whether its a number or an additional roll.
 * CreatureLootOption is an interface and goes on specific creatures
 * to tie them to loot tables with numbers of times to roll on each, or it can
 * have instead coinage rolls.
 */
export class LootTable extends ModelBase {
  data_type: DataType = "loot_table";
  loot_options: LootOption[] = [];
  dice_size = 0;
  dice_count = 0;
  
  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.loot_options = obj.loot_options ? obj.loot_options : [];
      this.dice_size = obj.dice_size ? obj.dice_size : 0;
      this.dice_count = obj.dice_count ? obj.dice_count : 0;
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.loot_options = obj.loot_options ? obj.loot_options : [];
  //     this.dice_size = obj.dice_size ? obj.dice_size : 0;
  //     this.dice_count = obj.dice_count ? obj.dice_count : 0;
  //   }
  // }

  toDBObj(): any {
    const base_db_obj = super.toDBObj();
    return {
      ...base_db_obj,
      loot_options: this.loot_options,
      dice_size: this.dice_size,
      dice_count: this.dice_count
    };
  }

  clone(drop_ids = false): LootTable {
    const new_obj = new LootTable();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  copy(copyMe: LootTable, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.loot_options = [...copyMe.loot_options];
    this.dice_size = copyMe.dice_size;
    this.dice_count = copyMe.dice_count;
  }
}

export interface LootOption {
  true_id: string;
  rarity: number; // The rarity of the item
  item_type: string; // The type of the item
  base_item_id?: string; // The specific base_item_id if it has one
  magic_item_id?: string; // The specific magic_item_id if it has one
  magic_item_keyword_ids?: string[]; // Any magic_item_keyword_ids to attach
  min_roll: number; // The minimum number rolled to get this option
  max_roll: number; // The maximum number rolled to get this option
  dice_size?: number; // If it should trigger a roll to see how many of the item you get, then this says the dice_size of dice to roll
  dice_count: number; // In most cases this is how many of the item (usually 1), but if dice_size is greater than 1 then it's how many dice to roll
}

export interface CreatureLootOption {
  type: string;
  loot_table_id?: string; // The id of the table to roll on
  rolls?: number; // How many times to roll
  coin_roll?: { 
    [coin_size: string]: CoinOption // CP, SP, EP, GP, PP
  };
}

export interface CoinOption {
  dice_size?: number; // Size of dice to roll
  dice_count?: number; // How many dice to roll
  flat?: number; // Modifier to add
}
